import {
  oneErrorOnNotOkFetchye,
} from '@americanexpress/fetchye-amex';
import {
  getActiveLocaleSelector,
  getEnvironmentSelector,
  getTenancySelector,
} from '@americanexpress/travel-selectors';
import { getTravelFeatureFlagsOneCmsUrlSelector } from '../selectors/cmsSelector';
import { fetchyeOpts, generateReporting } from '../utils/apiUtils';

const getTravelFeatureFlagsThunk = async (
  dispatch,
  getState
) => {
  const state = getState();
  return dispatch(
    oneErrorOnNotOkFetchye(
      `${getTravelFeatureFlagsOneCmsUrlSelector(state)}`,
      fetchyeOpts,
      generateReporting(
        'src/thunks/TravelFeatureFlagsThunk'
      )
    )
  );
};

export const isCmsFlagEnabledThunk = (flag) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const locale = getActiveLocaleSelector(state);
  const environment = getEnvironmentSelector(state);
  const tenancy = getTenancySelector(state);
  const { data } = await getTravelFeatureFlagsThunk(dispatch, getState);
  return data?.body?.[flag]?.[tenancy]?.[environment]?.includes(locale) || false;
};
